/** Checks objects for shallow equality ignoring given keys & objects & arrays */
export const isShallowEqual = <T extends object>(
  a: T,
  b: T,
  ignoreKeys?: (keyof T)[],
): boolean => {
  if (a === b) {
    return true;
  }
  for (const k of Object.keys(a) as (keyof T)[]) {
    if (ignoreKeys?.includes(k)) {
      continue;
    }
    const av = a[k];
    const bv = b[k];
    const t = typeof av;
    if (
      t === 'function' ||
      (t === 'object' && av !== null) ||
      Array.isArray(av)
    ) {
      continue;
    }
    if (av !== bv) {
      return false;
    }
  }
  return true;
};
